
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { AthleteReportCategory } from '@/models'
import { AppHostnameMixin, BAIconsMixin, ColorMixin, StringsMixin } from '@/mixins';

@Component
export default class ScoutingScoreSummaryV3 extends Mixins(BAIconsMixin, AppHostnameMixin, ColorMixin, StringsMixin){
	@Prop() category: AthleteReportCategory;
   	@Prop({default: 0}) precision: number;
	@Prop({type: Boolean}) blurred;
	@Prop({type: Boolean}) hideComments;

	get Score(): number {
		if( this.IsEmpty(this.category?.score) ) return undefined;
		let score: number = Number(this.category.score);
		return score;
	}
	get Notes(): string {
		if( this.IsEmpty(this.category?.notes) ) return ' ';
		return this.category.notes;
	}

}
